import { type RouteObject } from 'react-router-dom';

export const authRoutes: RouteObject = {
  path: 'auth',
  children: [
    {
      path: 'google',
      children: [
        {
          path: 'validate',
          lazy: () => import('../../app/auth/GoogleAuthValidation'),
        },
      ],
    },
    {
      path: 'apple',
      children: [
        {
          path: 'validate',
          lazy: () => import('../../app/auth/AppleAuthValidation'),
        },
      ],
    },
    {
      path: 'outlook',
      children: [
        {
          path: 'validate',
          lazy: () => import('../../app/auth/OutlookAuthValidation'),
        },
      ],
    },
  ],
};
